<script setup>
import { ref, computed, inject, watch } from "vue";
import { useStore } from "vuex";

const store = useStore();
const isRTL = computed(() => store.state.argonConfig.isRTL);

const props = defineProps({
  collapseRef: {
    type: String,
    required: true,
  },
  navText: {
    type: String,
    required: true,
  },
  collapse: {
    type: Boolean,
    default: true,
  },
});

const isExpanded = ref(false);
const activeMenu = inject('activeMenu', null);
const setActiveMenu = inject('setActiveMenu', null);

if (activeMenu && setActiveMenu) {
  watch(activeMenu, (newVal) => {
    if (newVal !== props.collapseRef) {
      isExpanded.value = false;
    }
  });
}

const handleClick = () => {
  isExpanded.value = !isExpanded.value;
  if (isExpanded.value && setActiveMenu) {
    setActiveMenu(props.collapseRef);
  } else if (!isExpanded.value) {
    // Close semua sub-child pas parent close
    const subChildElements = document.querySelectorAll(`#${props.collapseRef} .collapse`);
    subChildElements.forEach(el => {
      el.classList.remove('show');
    });
  }
};
</script>
<template>
  <a
    :data-bs-toggle="collapse ? 'collapse' : ''"
    :href="collapse ? `#${collapseRef}` : collapseRef"
    :aria-controls="collapseRef"
    :aria-expanded="isExpanded"
    class="nav-link d-flex align-items-center nav-link-compact"
    v-bind="$attrs"
    @click="handleClick"
  >
    <div
      class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
    >
      <slot name="icon"></slot>
    </div>
    <span class="nav-link-text" :class="isRTL ? ' me-1' : 'ms-0'">{{
      navText
    }}</span>
  </a>
  <div :class="isExpanded ? 'collapse show' : 'collapse'">
    <slot name="list"></slot>
  </div>
</template>

<style>
.navbar-vertical.navbar-expand-xs .navbar-nav .nav-link.nav-link-compact {
  padding-top: 0.4rem !important;
  padding-bottom: 0.4rem !important;
}

.navbar-vertical .navbar-nav .nav-link .nav-link-text {
  font-size: 0.85rem !important;
}
</style>
